<template>
  <div>
    <Subtitle v-if="title" :text="title" customClass="mb-4"> </Subtitle>
    <v-row align="stretch" v-if="attendees">
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="attendee in attendees"
        :key="attendee.personal_record_id"
      >
        <v-skeleton-loader
          v-if="attendeesLoading"
          :loading="true"
          type="list-item-avatar"
        ></v-skeleton-loader>
        <EventAvatarCard
          @edit="handleAttendeeEdit"
          @delete="handleAttendeeDelete"
          v-else
          :attendee="attendee"
          :reply="attendee.reply"
          :is-editable="isEditable"
          :guests-allowed="guestsAllowed"
          :view-context="viewContext"
        >
        </EventAvatarCard>
      </v-col>
      <v-col cols="12" v-if="isLoadMoreAvailable">
        <TextButton
          :disabled="loadingMore"
          :label="$t('components.attendee_list.show_more')"
          @click="loadMore"
          color="textColor"
          block
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import AvatarCard from "components/UI/AvatarCard.vue"
import { mdiAccountMultipleOutline } from "@mdi/js"
import TextButton from "components/UI/TextButton.vue"
import Subtitle from "components/UI/Subtitle.vue"
import { Rsvp } from "suus-api"
import useTranslate from "features/common/translate/concerns/useTranslate"
import EventAvatarCard from "features/events/attendees/event-attendee-list/EventAvatarCard.vue"
import { ViewContext } from "concerns/useContextName"

export default defineComponent({
  name: "EventAttendeeListSection",
  components: { EventAvatarCard, Subtitle, TextButton, AvatarCard },
  props: {
    attendees: {
      type: Array as () => Rsvp[],
      required: true,
    },
    attendeesLoading: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    isEditable: {
      type: Boolean,
    },
    guestsAllowed: {
      type: Boolean,
    },
    isLoadMoreAvailable: {
      type: Boolean,
      default: false,
    },
    loadingMore: {
      type: Boolean,
    },
    viewContext: {
      type: Object as PropType<ViewContext>,
    },
  },
  methods: {
    attendeeGuestsText(attendeeCount: number) {
      return this.tc("guest", attendeeCount)
    },
    handleAttendeeEdit(saveObject) {
      this.$emit("editAttendee", saveObject)
    },
    handleAttendeeDelete(personalRecordId) {
      this.$emit("deleteAttendee", personalRecordId)
    },
    loadMore() {
      this.$emit("loadMore")
    },
  },
  setup() {
    const { tc } = useTranslate("components.attendee_list")
    return {
      guestsIcon: mdiAccountMultipleOutline,
      tc,
    }
  },
})
</script>
